export default __webpack_public_path__ + "static/media/download-duotone.8cc87566.svg";